import styled from 'styled-components/macro';

export const Container = styled.div`
  padding: 1rem 1.2rem;

  .NoPaddingLeft {
    padding-left: 0;
  }
`;
